<template>
    <div class="cc-product">
        <div class="cc-product__image">
            <a :href="product.link" :title="product.name" class="cc-product__image__link">
                <img :src="product.thumbnail" :alt="product.name" class="cc-product__image__thumbnail"/>
            </a>
        </div>
        <div class="cc-product__information">
            <div class="cc-product__header">
                <div class="cc-product__title">
                    <a :href="product.link" :title="product.name" class="cc-product__title__link">{{ product.name }}</a>
                </div>
                <div class="cc-product__controls">
                    <button :title="translations['Remove product']" class="cc-product__control" @click="removeProduct">&times;</button>
                </div>
            </div>
            <div class="cc-product__main">
                <div class="cc-product__attributes">
                    {{ product.attributes }}
                </div>
                <div class="cc-product__availability">
                    <availability :quantity="product.quantity_available" :available_now="product.available_now" :available_later="product.available_later"/>
                </div>
                <div class="cc-product__quantity">
                    <div class="cc-quantity">
                        <div @click="decreaseQuantity()" class="cc-quantity__control cc-quantity__control--minus">&minus;</div>
                        <input @change="setQuantity" type="text" name="quantity" class="cc-quantity__input" :placeholder="product.cart_quantity"/>
                        <div @click="increaseQuantity()" class="cc-quantity__control cc-quantity__control--plus">&plus;</div>
                    </div>
                </div>
                <div class="cc-product__price">
                    <div class="cc-price cc-price--product">{{ displayProductPrice }}</div>
                </div>
            </div>
        </div>
        <div class="cc-product__mobile">
            <div class="cc-product__mobile-quantity">
                <div class="cc-quantity">
                    <div @click="decreaseQuantity()" class="cc-quantity__control cc-quantity__control--minus">&minus;</div>
                    <input @change="setQuantity" type="text" name="quantity" class="cc-quantity__input" :placeholder="product.cart_quantity"/>
                    <div @click="increaseQuantity()" class="cc-quantity__control cc-quantity__control--plus">&plus;</div>
                </div>
            </div>
            <div class="cc-product__mobile-price">
                <div class="cc-price cc-price--product">{{ displayProductPrice }}</div>
            </div>
            <div class="cc-product__mobile-controls">
                <button :title="translations['Remove product']" class="cc-product__control" @click="removeProduct">&times;</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Availability from "./Availability";

    export default {
        components: {
            Availability
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
            displayProductPrice: function () {
                return this.product.is_gift ? this.translations['Free'] : this.product.formattedPrices.total_with_tax;
            },
        },
        methods: {
            removeProduct: function () {
                this.$store.dispatch('products/REMOVE', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute
                });
            },
            increaseQuantity: function () {
                this.$store.dispatch('products/INCREASE_QUANTITY', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute
                })
            },
            decreaseQuantity: function () {
                this.$store.dispatch('products/DECREASE_QUANTITY', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute
                })
            },
            setQuantity: function (event) {
                const quantity = event.target.value;
                this.$store.dispatch('products/SET_QUANTITY', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute,
                    quantity: quantity,
                    cart_quantity: this.product.cart_quantity
                }).then(() => {
                    event.target.value = '';
                })
            }
        },
        name: 'Product',
        props: [
            'product',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/global/main";

    #app {
        .cc-product {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: 100%;
            background: $product-background-color;
        }

        .cc-product__image {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: center;
            align-items: center;
            width: 20%;
        }

        .cc-product__image__thumbnail {
            display: block;
            max-width: 100%;
            max-height: 120px;
        }

        .cc-product__information {
            width: 80%;
        }

        .cc-product__header {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }

        .cc-product__title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            padding: 1rem;

            @include mobile {
                width: 100%;
            }

            @include desktop {
                width: calc(100% - 50px);
            }
        }

        .cc-product__title__link {
            text-decoration: none;
            color: $product-title-color;
            font-family: $product-title-font-family;
            font-size: $product-title-font-size;
            font-weight: $product-title-font-weight;
            @if ($product-title-uppercase) {
                text-transform: uppercase;
            }
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .cc-product__controls {
            @include mobile {
                display: none;
            }

            @include desktop {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-end;
                align-items: center;
                width: 50px;
                padding: 1rem;
            }
        }

        .cc-product__control {
            background-color: $product-control-background-color;
            border: $product-control-border;
            color: $product-control-color;
            font-weight: $product-control-font-weight;

            @include mobile {
                font-size: 34px;
            }

            @include desktop {
                font-size: 24px;
            }
        }

        .cc-product__main {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }

        .cc-product__attributes {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            padding: 1rem;
        }

        .cc-product__availability {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            padding: 1rem;

            @include mobile {
                width: 100%;
            }

            @include desktop {
                width: 45%;
            }
        }

        .cc-product__quantity {
            @include mobile {
                display: none;
            }

            @include desktop {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: center;
                align-items: center;
                width: 25%;
                padding: 1rem;
            }
        }

        .cc-product__price {
            @include mobile {
                display: none;
            }

            @include desktop {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-end;
                align-items: center;
                width: 30%;
                padding: 1rem;
            }
        }

        .cc-product__mobile {
            @include mobile {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                width: 100%;
            }

            @include desktop {
                display: none;
            }
        }

        .cc-product__mobile-quantity {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            width: 35%;
            padding: 1rem;
        }

        .cc-product__mobile-price {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-end;
            align-items: center;
            width: calc(65% - 50px);
            padding: 1rem;
        }

        .cc-product__mobile-controls {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: center;
            align-items: center;
            width: 50px;
            padding: 1rem;
        }
    }
</style>
